import {computed,ref,onMounted, watch} from 'vue'
import {useStore} from 'vuex'
export default {
    name: "ProductDetailBar",
    props: {
        prices: {
            type: Object,
            required: true
        },
        tax: {
            type: Object,
            required: true
        }
    },
    setup(props){
        const store = useStore()
        const ready = ref(false)
        const showMsrp = computed(()=>store.state.ecom.show_msrp)
        const priceBox = ref(null)
        const taxBox = ref(null)

        onMounted(()=>{
            ready.value = true
        })

        watch(showMsrp,()=>{
            priceBox.value.innerText = (showMsrp.value ? props.prices.msrp : props.prices.price)
            taxBox.value.innerText = (showMsrp.value ? props.tax.msrpTax : props.tax.tax)
        })

        return {
            showMsrp,
            ready,
            priceBox,
            taxBox
        }
    }
}
